<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <!-- <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 조회</h3>
        <article class="selectOpt type02">
          <dl>
            <dt>
              <h4 class="tit">차량번호 조회</h4>
              <p class="subTxt">공영주차 정기권을 조회/결제하실 수 있습니다.</p>
            </dt>
            <dd>
              <input
                type="text"
                title="차량번호 입력"
                placeholder="123가4567"
                v-model="carNo"
                maxlength="10"
                @keyup.enter="findPeriod"
              />
              <button type="button" class="btn dkGray" @click="findPeriod">조회</button>
            </dd>
          </dl>
        </article>
        <article>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  정기권 조회 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">차량번호</th>
                    <th scope="col">신청 공영주차장</th>
                    <th scope="col">이용기간</th>
                    <th scope="col">신청구분</th>
                    <th scope="col">배정방식</th>
                    <th scope="col">신청일</th>
                    <th scope="col">신청상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="nodata" class="nodate">
                    <td colspan="7" v-if="isLoading"><loading-spinner></loading-spinner></td>
                    <td colspan="7" v-else>조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item)">
                    <td>{{ item.carNo }}</td>
                    <td>[{{ item.parkingDivCdNm }}] {{ item.parkingNm }}</td>
                    <td v-if="item.useStartDt == '' && item.useEndDt == ''">-</td>
                    <td v-else>{{ item.useStartDt | ptDateFormat }} ~ {{ item.useEndDt | ptDateFormat }}</td>
                    <td>{{ item.useDivCdNm }}</td>
                    <td>{{ item.periodAllotType }}</td>
                    <td>{{ item.reqDt }}</td>
                    <td v-if="item.procStsCd == 'MUT-001'" class="black">
                      <span class="state application">신청중</span>
                    </td>
                    <td v-if="item.procStsCd == 'MUT-002'">
                      <span class="state paid">배정-완납</span>
                    </td>
                    <td v-if="item.procStsCd == 'MUT-003'">
                      <span class="period-cancel">배정해지</span>
                    </td>
                    <td
                      v-if="item.procStsCd == 'MUT-004' || item.procStsCd == 'MUT-005' || item.procStsCd == 'MUT-006'"
                    >
                      <span class="state unpaid">배정-미납</span>
                    </td>

                    <!-- <td><span class="state application">신청중</span></td>
                                        <td><span class="state standBy">배정대기중</span></td>
                                        <td><span class="state paid">배정-완납</span></td>
                                        <td><span class="state unpaid">배정-미납</span></td>
                                        <td><span class="state completion">신청완료</span></td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
          <p class="info">자신의 차량번호를 선택하여 주세요. 타인의 차량 결제 시 환불되지 않으니 확인하여 주십시오.</p>
        </article>
        <article class="infoBox">
          <div class="stateList">
            <dl>
              <dt><span class="application">신청중</span></dt>
              <dd>정기권 신청이 완료된 상태</dd>
            </dl>
            <dl>
              <dt><span class="unpaid">배정-미납</span></dt>
              <dd>정기권 차량 배정이 되었으나 결제가 되지 않은 상태</dd>
            </dl>
            <dl>
              <dt><span class="completion">신청완료</span></dt>
              <dd>정기권 신청은 되었으나 차량이 배정되지 않은 상태</dd>
            </dl>
            <dl>
              <dt><span class="paid">배정-완납</span></dt>
              <dd>차량 배정 및 결제가 완료 된 상태</dd>
            </dl>
            <dl>
              <dt><span class="standBy">배정대기중</span></dt>
              <dd>차량이 미배정되어 배정 대기 상태(대기순번)</dd>
            </dl>
          </div>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import AlertMatch from '../../../components/Alert01.vue';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      msg: '',
      curPageNum   : 1,
			dataPerPage  : 10,
      nodata: true,
      periodList: [],
      isLoading: false,
      carNo: '',
    };
  },

  components: {
    AlertMatch,
    LoadingSpinner,
  },
  
  mounted() {
    this.searchPeriodList();
  },

  methods: {
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;
    },

    validate() {
      const carNoRegex = /^([가-히]{2}){0,1}[0-9]{1,3}[가-히]{1}[0-9]{4}$/gi;
      if (!this.carNo || !carNoRegex.test(this.carNo.replace(/\s/gi, ''))) {
        this.msg = '차량번호가 형식에 맞지 않습니다.';
        this.showModalMsgSuccess = true;
        return false;
      }
      return true;
    },

    async searchPeriodList() {

      this.isLoading = true;

      const res = await axios('get', '/api/period/searchPeriodList.json', {
        carNo: this.carNo.replace(/\s/gi, ''),
        pageIndex: this.curPageNum,
        pageUnit: 10,
      });

      const data = res.data.value.result;

      if (!data || data.length < 0) {
        this.periodList = [];
        this.nodata = true;
        this.isLoading = false;
        return;
      }

      this.periodList = data;
      this.nodata = false;
      this.isLoading = false;
      this.curPageNum = 1;

    },

    findPeriod() {
      
      if (!this.validate()) {
        return;
      }

      this.searchPeriodList();
      
    },

    view: function (item) {
      if (item.procStsCd === 'MUT-001') {
        return;
      }
      const params = {
        carNo: item.carNo,
        periodId: item.periodId,
      };
      this.$router.push({
        name: 'periodview',
        params: { data: params },
      });
    },
  },
  
  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.periodList.length / this.dataPerPage);
    },
    calData() {
      if (this.periodList.length < 0) {
        return;
      }
      return this.periodList.slice(this.startOffset, this.endOffset);
    },
  },
  
};
</script>
